import { map, includes, reject } from 'lodash-es';
import { useField, useFormikContext } from 'formik';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Checkbox from '@mui/material/Checkbox';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  field: {
    margin: theme.spacing(1, 0),
  },
  label: {
    marginBottom: theme.spacing(1),
  },
  checkbox: {
    paddingTop: 0,
    paddingBottom: 0,
  },
}));

type CheckboxOption = {
  value: string;
  label: React.ReactNode;
  className?: string;
};

type Props = {
  name: string;
  label?: React.ReactNode;
  options: CheckboxOption[];
  disabled?: boolean;
  touched?: boolean;
  helperText?: string;
  className?: string;
};

const CheckboxGroupField = ({ name, label, options, disabled, touched: formTouched, helperText, className }: Props) => {
  const { classes, cx } = useStyles();
  const [field, meta] = useField(name);
  const { setFieldValue } = useFormikContext();
  const touched = formTouched || meta.touched;
  const currentError = meta.error;

  return (
    <FormControl
      component="fieldset"
      error={touched && Boolean(currentError)}
      className={cx(classes.field, className)}
    >
      {label && <FormLabel component="legend" className={classes.label}>{label}</FormLabel>}
      <FormGroup>
        {map(options, (option) => {
          return (
            <FormControlLabel
              key={option.value}
              control={(
                <Checkbox
                  id={name}
                  onChange={(event) => {
                    const checked = event.target.checked;
                    let newValue;
                    if (checked) {
                      newValue = field.value.concat(option.value);
                    } else {
                      newValue = reject(field.value, (v) => v === option.value);
                    }
                    setFieldValue(field.name, newValue);
                  }}
                  value={option.value}
                  checked={includes(field.value, option.value)}
                  classes={{ root: classes.checkbox }}
                />
              )}
              label={option.label}
              disabled={disabled}
            />
          )
        })}
      </FormGroup>
      {((touched && currentError) || helperText) && (
        <FormHelperText>
          {(touched && currentError) || helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default CheckboxGroupField;
